import { TinyMCEExtensionBuilder } from '../JTinyMCEExtensions';
import { IntlShape } from 'react-intl';
import { Editor } from 'tinymce';

const LOCAL_STORAGE_KEY = 'isMarkdownActive';
const MARKDOWN_TEXT_PATTERNS = [
    { start: '*', end: '*', format: 'italic' },
    { start: '_', end: '_', format: 'italic' },
    { start: '**', end: '**', format: 'bold' },
    { start: '__', end: '__', format: 'bold' },
    { start: '~~', end: '~~', format: 'strikethrough' },
    { start: '`', end: '`', cmd: 'CodeSample' },
    { start: '#', format: 'h1' },
    { start: '##', format: 'h2' },
    { start: '###', format: 'h3' },
    { start: '####', format: 'h4' },
    { start: '#####', format: 'h5' },
    { start: '######', format: 'h6' },
    { start: '1.', cmd: 'InsertOrderedList' },
    { start: '*', cmd: 'InsertUnorderedList' },
    { start: '-', cmd: 'InsertUnorderedList' },
    { start: '---', cmd: 'InsertHorizontalRule' },
    { start: '```', cmd: 'CodeSample' },
];

export const MarkdownExtension: TinyMCEExtensionBuilder<[(editor: Editor) => void, IntlShape]> = (openModal, intl) => {
    return {
        setup: (editor) => {
            editor.ui.registry.addIcon(
                'markdown',
                '<svg height="24" width="24" viewBox="0 0 640 512"><path d="M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"/></svg>',
            );
            editor.ui.registry.addSplitButton('markdown', {
                icon: 'markdown',
                tooltip: intl.formatMessage({ id: 'TINY_MCE_Markdown_Shortcuts' }),
                onAction: (api) => {
                    if (api.isActive()) {
                        localStorage.removeItem(LOCAL_STORAGE_KEY);
                        editor.options.set('text_patterns', []);
                    } else {
                        localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
                        editor.options.set('text_patterns', MARKDOWN_TEXT_PATTERNS);
                    }
                    api.setActive(!api.isActive());
                },
                onSetup: (api) => {
                    const isActive = !!localStorage.getItem(LOCAL_STORAGE_KEY);
                    api.setActive(isActive);
                    if (isActive) {
                        editor.options.set('text_patterns', MARKDOWN_TEXT_PATTERNS);
                    }
                    return () => null;
                },
                onItemAction: () => openModal(editor),
                fetch: (callback) => {
                    callback([
                        {
                            type: 'choiceitem',
                            text: intl.formatMessage({ id: 'TINY_MCE_Insert_Markdown' }),
                        },
                    ]);
                },
            });
        },
    };
};
